import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Component that redirects URLs with trailing slashes to their non-trailing slash equivalent
 * Example: /p/:username/ -> /p/:username
 */
const TrailingSlashRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname, search, hash } = location;

    // Check if the pathname ends with a slash and is not the root path
    if (pathname !== "/" && pathname.endsWith("/")) {
      // Remove the trailing slash
      const newPathname = pathname.slice(0, -1);

      // Navigate to the new URL without the trailing slash
      // Using replace: true to avoid adding to browser history
      navigate(
        {
          pathname: newPathname,
          search,
          hash,
        },
        { replace: true }
      );
    }
  }, [location, navigate]);

  return null;
};

export default TrailingSlashRedirect;
